
export type OffsetDateTime = string;

export type LocalDate = string;

export type BigDecimal = number;

export interface PaginationResponse<T> {
    limit: number;
    offset: number;
    maxResults: number;
    results: Array<T>;
}

export interface PaginationParams {
    limit?: Number | null,
    offset?: Number | null
}


export class PaginatableResults<T> {
    limit: number;
    offset: number;
    maxResults: number;
    results: Array<T>;

    constructor(response: PaginationResponse<T> | null) {
        if (response) {
            this.limit = response.limit
            this.offset = response.offset
            this.maxResults = response.maxResults
            this.results = response.results
        } else {
            this.limit = 0
            this.offset = 0
            this.maxResults = 0
            this.results = []
        }
    }

    pageNo(): Number {
        if (this.limit && this.offset) {
            return Math.floor(this.offset / this.limit) + 1;
        }
        return 1;
    }

    maxPages(): number {
        let pages = 0;
        if (this.maxResults && this.limit) {
            pages = Math.floor(this.maxResults / this.limit);
            if (this.maxResults % this.limit > 0) {
                pages++;
            }
        }
        return pages;
    }

    hasNext(): boolean {
        if (this.results.length && this.maxResults) {
            return (this.offset + this.results.length) < this.maxResults;
        }
        return false;
    }

    hasPrevious(): boolean {
        return !!this.offset;
    }
}